import {
    CLAPI
} from '../clchart/cl.api.js'
import { formatPrice } from '../clchart/cl.utils.js'
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 90

export const SPOOLCLASS = ['zeasy0']

export const MINUTES = [945, 1045, 1330, 1445]

export const CHART_SPOOL_MCLASS = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '信号分类',
    },
    maxchs: 4,
    ctrls: []
}

export function onInit() {
    CHART_SPOOL_MCLASS.ctrls = []
    for (let wvi = 0; wvi < SPOOLCLASS.length; wvi++) {
        CHART_SPOOL_MCLASS.ctrls.push({
            label: SPOOLCLASS[wvi],
            clickValue: SPOOLCLASS[wvi],
        })
    }
}

const signal_fields = 'code,status,midp,newp,dates3,drate3,minus3,mrate3,nminus,minustr,codeclr'

const FIELD_SIGNAL = DATAS.fieldsMergeFieldsIndex('index,name,rate', signal_fields)

const ARRAY_SIGNAL = DATAS.strsToArray(signal_fields);

export const signalInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '入选价',
        maxchs: 6,
        color : 'yellow',
        field: 'midp',
        getvar : 'getPrcVar', 
    },
    // {
    //     label: '最新价',
    //     maxchs: 6,
    //     field: 'newp',
    //     change: true,   // change:true 表示如果数值有变化，显示动画效果
    //     getclr : 'getPrcClr', 
    //     getvar : 'getPrcVar', 
    // },
    // {
    //     label: '涨幅',
    //     maxchs: 6,
    //     field: 'rate',
    //     getclr : 'getZeroClr', 
    //     getvar : 'getPctVar', 
    // },
    {
        label: '日',
        maxchs: 2,
        field: 'dates3',
        getclr : 'getVolClr', 
        getvar : 'getIntVar', 
    },
    {
        label   : '分',
        maxchs  : 2,
        field   : 'minus3',
        getclr  : 'getVolClr', 
        getvar  : 'getStrVar', 
    },
    {
        label   : '新',
        align   : 'center',
        maxchs  : 1,
        sort    : 'string',
        color   : 'red',
        field   : 'minustr',
        getvar  : 'getStrVar', 
    },
];


export function mergeAsignal(newdata, agodata, newpInfo) {
    
    let codes = {}
    // console.log(agodata);
    
    if (agodata.datas.length > 0) {
        for (let index = 0; index < agodata.datas.length; index++) {
            const code = CLAPI.getData(agodata, 'code', index)
            const dates = CLAPI.getData(agodata, 'dates3', index)
            const drate = CLAPI.getData(agodata, 'drate3', index)
            const minus = CLAPI.getData(agodata, 'minus3', index)
            const mrate = CLAPI.getData(agodata, 'mrate3', index)
            if (dates > 2 && minus > 0) {
                if (codes[code] === undefined) {
                    codes[code] = { 
                        dates3 : CLAPI.getData(agodata, 'dates3', index),
                        drate3 : CLAPI.getData(agodata, 'drate3', index),
                        minus3 : CLAPI.getData(agodata, 'minus3', index),
                        mrate3 : CLAPI.getData(agodata, 'mrate3', index),
                        midp   : CLAPI.getData(agodata, 'midp', index),
                        status : CLAPI.getData(agodata, 'status', index),
                        // msec   : CLAPI.getData(agodata, 'msecstamp', index),
                        nminus : 0,
                    }
                }
            }
        }
    }
    if (newdata.infos) {
        for (let index = 0; index < newdata.infos.length; index++) {
            if (newdata.infos[index].kname[0] === 'C') {
                continue
            }
            const code = newdata.infos[index].kname
            if (codes[code] === undefined) {
                codes[code] = { 
                    dates3 : 0,
                    drate3 : 0,
                    minus3 : 0,
                    mrate3 : 0,
                    midp   : newdata.infos[index].midp,
                    status : newdata.infos[index].status,
                    // msec   : newdata.infos[index].msecstamp,
                    nminus : 1,
                }
            }
            else {
                codes[code].midp   = newdata.infos[index].midp
                codes[code].status = newdata.infos[index].status
                // codes[code].msec   = newdata.infos[index].msecstamp,
                codes[code].nminus = codes[code].nminus + 1;
            }
            // 更新一下价格
            const curMsec =  CLAPI.Utils.strMsecToMTime(newdata.infos[index].msecstamp)
            // if (code === 'SH600693') {
            //     console.log(curMsec, newpInfo[code].msec, newpInfo[code].newp, newdata.infos[index].midp);               
            // }
            if (curMsec >= newpInfo[code].msec) {
                newpInfo[code].msec = curMsec
                newpInfo[code].newp = newdata.infos[index].midp
            }
        }
    }

    // console.log(codes);
    return codes;
}

export function codeinfoToAsignal(codeinfo, newpInfo) {

    let signals = []

    for (let code in codeinfo) {

        let minustr = codeinfo[code].nminus > 0 ? String(codeinfo[code].nminus) : ' '

        signals.push([
            code,
            codeinfo[code].status,
            codeinfo[code].midp,
            newpInfo[code].newp,
            codeinfo[code].dates3,            
            codeinfo[code].drate3,
            codeinfo[code].minus3,
            codeinfo[code].mrate3,
            codeinfo[code].nminus,
            minustr,
            '',
        ])
        // console.log(codes[code].minus);
    }
    return { fields : DATAS.fieldsToFieldsIndex(signal_fields), datas: signals}    
}

export function GetAsignalTable(indata, keyInfo, newpInfo) {
    let signal = []
    let codes = {}
    for (let index = 0; index < indata.datas.length; index++) {
        
        const code = CLAPI.getData(indata, 'code', index)
        const midp = CLAPI.getData(indata, 'midp', index)
        
        const rate = newpInfo[code] === undefined ? 0.0 : (newpInfo[code].newp - midp) / midp
        signal = [
            keyInfo[code].static.name,
            rate,
        ]
        for (let fdi = 0; fdi < ARRAY_SIGNAL.length; fdi++) {
            signal.push(CLAPI.getData(indata, ARRAY_SIGNAL[fdi], index))
        }
        if (codes[code] === undefined) {
            codes[code] = { signal, nums : 1}
        }
        else {
            codes[code].signal = signal
            codes[code].nums ++
        }
    }
    let signals = []
    for (let codeinfo in codes) {
        codes[codeinfo].signal.unshift(signals.length + 1)
        signals.push(codes[codeinfo].signal)
    }
    return { fields : FIELD_SIGNAL, datas: signals}    
}

// kname,code,msec,status,agop,open,maxp,minp,newp,sumchip_sumv0,sumchip_sump0,sumchip_reap0,sumchip_volr0,
// sumchip_maxv0,sumchip_sumv1,sumchip_sump1,sumchip_reap1,sumchip_volr1,sumchip_maxv1,sumchip_sumv2,sumchip_sump2,
// sumchip_reap2,sumchip_volr2,sumchip_maxv2,maxsumv,vrset0,vrset1,vrset2,vrdeg0,vrdeg1,vrdeg2,
// cmveer,cwveer,svdate,sprchg,svrchg0,svrchg1,svrchg2,smveer,swveer,mnymood,volravgx0,volravgx1,
// volravgx2,volravgx3,volravgx4,volravgy0,volravgy1,volravgy2,volravgy3,volravgy4,volravgz0,volravgz1,volravgz2,
// volravgz3,volravgz4,vpuprate0,vpuprate1,vpuprate2,vpdnrate0,vpdnrate1,vpdnrate2,
// avg60p,pgrade,fright,pshape,mvolr60,mvolr10,oupdays,aupdays,kupdays,kdndays,jupdays,jdndays,lupdays,ldndays

export const chip3_fields = "code,msec,status,newp,cwveer,swveer,avg60p,pgrade,fright,pshape,mvolr60,mvolr10,upstops,dnstops,oupdays,aupdays,kupdays,kdndays,jupdays,jdndays,lupdays,ldndays"

const FIELD_CHIP3 = DATAS.fieldsToFieldsIndex('index,code,name,midp,newp,wrate,pgrade,shapestr,shapeclr,upstops,dnstops,ouprate,auprate,kuprate,kdnrate,juprate,jdnrate,luprate,ldnrate,mvolr10,mvolr60,swveer')

export const shareInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '预期倍率',
        maxchs: 7,
        field: 'swveer',
        getclr : 'getVolClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '短期仓位',
        maxchs: 7,
        field: 'mvolr10',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '长期仓位',
        maxchs: 7,
        field: 'mvolr60',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
];

export const gradeInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '等级',
        maxchs: 6,
        field: 'pgrade',
        getclr : 'getZeroClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: "形态",
        sort : 'string',
        field: 'shapestr',
        fieldclr: 'shapeclr',
        maxchs: 5,
        getvar : 'getStrVar',  
    },
    {
        label: '最新价',
        maxchs: 6,
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '涨幅',
        maxchs: 6,
        field: 'wrate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label   : '涨',
        maxchs  : 2,
        field   : 'upstops',
        getclr  : 'getVolClr', 
        getvar  : 'getStrVar', 
    },
    {
        label   : '跌',
        maxchs  : 2,
        field   : 'dnstops',
        getclr  : 'getVolClr', 
        getvar  : 'getStrVar', 
    },
    {
        label: "净买",
        field: 'kuprate',
        maxchs: 5,
        getclr : 'getIntClr', 
        getvar : 'getIntVar',  
    },
    {
        label: "普吸",
        field: 'juprate',
        maxchs: 5,
        getclr : 'getIntClr', 
        getvar : 'getIntVar',  
    },
    {
        label: "压吸",
        field: 'luprate',
        maxchs: 5,
        getclr : 'getIntClr', 
        getvar : 'getIntVar',  
    },
    {
        label: "净卖",
        field: 'kdnrate',
        maxchs: 5,
        getclr : 'getIntClr', 
        getvar : 'getIntVar',  
    },
    {
        label: "普出",
        field: 'jdnrate',
        maxchs: 5,
        getclr : 'getIntClr', 
        getvar : 'getIntVar',  
    },
    {
        label: "拉出",
        field: 'ldnrate',
        maxchs: 5,
        getclr : 'getIntClr', 
        getvar : 'getIntVar',  
    },
    
];
// wrate,shapeclr,ouprate,auprate,kuprate,juprate,luprate
export function GetPShareTable(codeinfo, achip3, keyInfo, newpInfo) {
    let chip3 = []
    let nums = 0
    for (let index = 0; index < achip3.datas.length; index++) {
        
        const code = CLAPI.getData(achip3, 'code', index)
        if (keyInfo[code] === undefined || keyInfo[code].static.name.indexOf("ST") !== -1) {
            continue
        }
        const mvolr10 = CLAPI.getData(achip3, 'mvolr10', index)
        const mvolr60 = CLAPI.getData(achip3, 'mvolr60', index)
        if (mvolr10 < 0.01 || mvolr60 < 0.01) {
            continue
        }
        const swveer = CLAPI.getData(achip3, 'swveer', index)
        if (codeinfo[code] === undefined) {
            if (swveer < 5.0) {
                continue
            }
        }
        const midp = CLAPI.getData(achip3, 'newp', index)
        
        let newp = 0.0
        let rate = 0.0
        if (newpInfo[code] !== undefined) {
            newp = newpInfo[code].newp
            rate = (newp - midp) / midp
        }
        
        chip3.push([
            ++nums,
            code,
            keyInfo[code].static.name,
            midp,
            newp,
            rate,
            0,
            '', '',
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            mvolr10,
            mvolr60,
            swveer,
        ])
        // nums++
    }
    return { fields : FIELD_CHIP3, datas: chip3}    
}

// wrate,shapeclr,ouprate,auprate,kuprate,juprate,luprate
export function GetPGradeTable(codeinfo, achip3, grade, keyInfo, newpInfo) {
    let chip3 = []
    let nums = 0
    
    for (let index = 0; index < achip3.datas.length; index++) {
        
        const code = CLAPI.getData(achip3, 'code', index)
        // if (codeinfo[code] === undefined) {
        //     continue
        // }
    
        if (keyInfo[code] === undefined || keyInfo[code].static.name.indexOf("ST") !== -1) {
            continue
        }
        const mvolr10 = CLAPI.getData(achip3, 'mvolr10', index)
        const mvolr60 = CLAPI.getData(achip3, 'mvolr60', index)
        if (mvolr10 < 0.01 || mvolr60 < 0.01) {
            continue
        }
        const swveer = CLAPI.getData(achip3, 'swveer', index)
        if (codeinfo[code] === undefined) {
            // if (swveer < 5.0) {
                continue
            // }
        }
        // console.log(codeinfo[code]);
        
        // if (codeinfo[code].dates3 < 3) {
        //     continue
        // }
        ///////
        const pgrade  = CLAPI.getData(achip3, 'pgrade', index)
        let selected = 0
        if (grade === 0 && pgrade <= -2.0) {
            selected = 1
        }
        if (grade === 1 && pgrade > -2.0 && pgrade <= -1.0) {
            selected = 1
        }
        if (grade === 2 && pgrade > -1.0 && pgrade <= 0.0) {
            selected = 1
        }
        if (grade === 3 && pgrade > 0.0) {
            selected = 1
        }
        if (selected === 0) {
            continue
        }
        if (swveer < 0.0) {
                continue
        }
        // 0 游离 1 波动 10 上穿 20 下破
        const pshape  = CLAPI.getData(achip3, 'pshape', index)
        let shapestr = '游离'
        let shapeclr = 'txt'
        if (pshape === 1) {
            shapestr = '波动'
            shapeclr = 'yellow'
        } 
        else if (pshape === 10) {
            shapestr = '上穿'
            shapeclr = 'red'
        } 
        else if (pshape === 20) {
            shapestr = '下破'
            shapeclr = 'green'
        } 

        const upstops = CLAPI.getData(achip3, 'upstops', index)
        const dnstops = CLAPI.getData(achip3, 'dnstops', index)
        const ouprate = CLAPI.getData(achip3, 'oupdays', index) // / 60
        const auprate = CLAPI.getData(achip3, 'aupdays', index) // / 60
        // const kuprate = (CLAPI.getData(achip3, 'kupdays', index) - CLAPI.getData(achip3, 'kdndays', index))  / 60
        // const juprate = (CLAPI.getData(achip3, 'jupdays', index) - CLAPI.getData(achip3, 'jdndays', index))  / 60
        // const luprate = (CLAPI.getData(achip3, 'lupdays', index) - CLAPI.getData(achip3, 'ldndays', index))  / 60
        const kuprate = (CLAPI.getData(achip3, 'kupdays', index)) // / 60
        const juprate = (CLAPI.getData(achip3, 'jupdays', index)) // / 60
        const luprate = (CLAPI.getData(achip3, 'lupdays', index)) // / 60
        const kdnrate = (CLAPI.getData(achip3, 'kdndays', index)) // / 60
        const jdnrate = (CLAPI.getData(achip3, 'jdndays', index)) // / 60
        const ldnrate = (CLAPI.getData(achip3, 'ldndays', index)) // / 60
        ///////
        if (juprate < jdnrate || luprate < ldnrate) {
            continue
        }
        const midp = CLAPI.getData(achip3, 'newp', index)
        
        let newp = 0.0
        let rate = 0.0
        if (newpInfo[code] !== undefined) {
            newp = newpInfo[code].newp
            rate = (newp - midp) / midp
        }
        // if (code === 'SH600693') {
        //     console.log(code, newp, midp, newpInfo[code]);
            
        // }
        chip3.push([
            ++nums,
            code,
            keyInfo[code].static.name,
            midp,
            newp,
            rate,
            pgrade,
            shapestr, 
            shapeclr,
            upstops,
            dnstops,
            ouprate,
            auprate,
            kuprate,
            kdnrate,
            juprate,
            jdnrate,
            luprate,
            ldnrate,
            0, 0, 0,
        ])
        // nums++
    }
    // wrate = formatPrice(wrate / nums * 100, 2) + '%';
    return { fields : FIELD_CHIP3, datas: chip3}  
}

export function SetPGradeTableNewp(gradedata, newkbar, newpInfo) {
    let hasnewp = false
    if (newkbar !== undefined && newkbar.datas.length > 0) {
        for (let index = 0; index < newkbar.datas.length; index++) {
            const code = CLAPI.getData(newkbar, 'code', index)
            const curMsec =  CLAPI.Utils.strMsecToMTime(CLAPI.getData(newkbar, 'msecstamp', index))
            if (curMsec >= newpInfo[code].msec) {
                newpInfo[code].msec = curMsec
                newpInfo[code].newp = CLAPI.getData(newkbar, 'newp', index)
            }
        }
        hasnewp = true
    }
    let wrate = 0.0

    for (let index = 0; index < gradedata.datas.length; index++) {
        if (hasnewp) {
            const code = CLAPI.getData(gradedata, 'code', index)
            const midp = CLAPI.getData(gradedata, 'midp', index)
            if (newpInfo[code] !== undefined) {
                const newp = newpInfo[code].newp
                const rate = (newp - midp) / midp
                gradedata.datas[index][4] = newp;
                gradedata.datas[index][5] = rate;
            }
        }
        wrate += CLAPI.getData(gradedata, 'wrate', index)
        // console.log(wrate, CLAPI.getData(gradedata, 'rate', index));
        
    }
    if (gradedata.datas.length > 0) {
        wrate = wrate / gradedata.datas.length
    }
    return wrate
}
